import type { FC } from "react";
import React from "react";
import { Box } from "@edreamsodigeo/prisma-design-system";

import { LightboxPopoverCircleNumber } from "~/components/acquisition/Lightbox/LightboxRevamp/components/LightboxFooter/components/LightboxPopoverCircleNumber";
import type { LightBoxPopoverCircleProps } from "~/components/acquisition/Lightbox/LightboxRevamp/components/LightboxFooter/contracts";
import { LightBoxPopoverCircleStyle } from "~/components/acquisition/Lightbox/LightboxRevamp/components/LightboxFooter/config/constants";

export const LightboxPopoverCircle: FC<LightBoxPopoverCircleProps> = ({
  number,
}) => (
  <Box
    backgroundColor={"primary.50"}
    p={"small"}
    sx={LightBoxPopoverCircleStyle}
  >
    <LightboxPopoverCircleNumber number={number} />
  </Box>
);
